<template>
   <ValidationObserver v-slot="{ handleSubmit, valid }" >
    <form 
        name="myf2g-silent-registration-form"
        id="myf2g-silent-registration-form"
        @submit.prevent="handleSubmit(submitForm)"
    >
      <div class="container-f2g black-container extra-padding-hp">
        <div class="f2g-wind-container">
            <div class="container-overlay overlay-form">
                <div class="title-overlay1">
                    {{ words['myf2g.login.silentreg.title'] }}
                </div>
                <div class="title-overlay4">
                    {{ words['myf2g.login.silentreg.subtitle1'] }}
                </div>
                <div class="form-overlay">
                    <div class="title-overlay3">
                        {{ words['myf2g.login.silentreg.subtitle2'] }} <span class="blue-font">({{msisdn}})</span>.
                    </div>
                    <ValidationProvider name="otp" rules="required"  v-slot="{ errors, validated, invalid }">
                      <div class="form-field">
                          <label class="form-label" for="first">{{ words['myf2g.login.silentreg.otp.label'] }}</label>
                          <input type="text" id="first" class="overlay-input-text form-input" v-model="otp" />
                          <template v-if="validated && invalid">
                            <span style="color:#FE4C6F;">{{ errors[0] }}</span>
                          </template>
                          <template v-else-if="responseErrorLevel != 0 && (responseErrorCode == 14005 || responseErrorCode == 11007 || responseErrorCode == 11010 || responseErrorCode == 12033)">
                            <span style="color:#FE4C6F;" v-html="responseErrorMessage"></span>
                          </template>
                      </div>
                    </ValidationProvider>

                    <ValidationProvider name="email" rules="required|email"  v-slot="{ errors, validated, invalid }">
                      <div class="form-field">
                          <label class="form-label" for="first">{{ words['myf2g.login.silentreg.email.label'] }}</label>
                          <input type="text" id="first" class="overlay-input-text form-input" v-model="email" />
                          <template v-if="validated && invalid">
                            <span style="color:#FE4C6F;">{{ errors[0] }}</span>
                          </template>
                      </div>
                    </ValidationProvider>

                    <ValidationProvider name="terms" :rules="{ required: { allowFalse: false } }" v-slot="{ errors, validated, invalid }">
                       
                      <div class="form_checkbox-wrapper ">                                  
                            <label class="margin-checkbox">       
                                <input type="checkbox" id="chkterms" name="chkterms" v-model="termsOfUse"  > 
                                <span class="checkbox-icon"></span>
                                <span class="form_checkbox form_checkbox--checkable checkbox-title">
                                    {{ words["f2g.login.silentreg.terms.part1"] }} <a :href="termsAndConditionsRedirection">{{ words["f2g.login.silentreg.terms.part2"] }}</a>

                                </span> 
                             </label>
                        </div>
                        <template v-if="validated && invalid">
                            <span style="color: #fe4c6f;">{{errors[0]}}</span>
                        </template>
                    </ValidationProvider>

                     
                      <div class="form_checkbox-wrapper ">                                  
                          <label class="margin-checkbox">       
                              <input type="checkbox" id="chknewsletter" name="chknewsletter" v-model="newsLetterRegister"  > 
                              <span class="checkbox-icon"></span>
                              <span class="form_checkbox form_checkbox--checkable checkbox-title">
                                  {{ words["f2g.login.silentreg.newsletter"] }}
                              </span> 
                           </label>
                      </div> 

                      <template v-if="responseErrorLevel != 0 && 
                                (responseErrorCode != 14005 && responseErrorCode != 11007  && 
                                responseErrorCode != 12033 && responseErrorCode != 11010)">
                        <span style="color:#FE4C6F;" v-html="responseErrorMessage"></span>
                      </template>

                </div>

                <div class="overlay-button-container button-register">
                    <div class="overlay-button-container button-register">
                        <input id="myf2g-silent-registration-input" name="myf2g-silent-registration-input" type="submit" class="container-button" :class="[valid ? 'blue-btn' : 'grey-btn']" :disabled="!valid" :value="words['myf2g.login.silentreg.submit']" />
                    </div>
                </div>
                <div class="paragr-text" style="cursor:pointer;" v-on:click="goBackToMobileForm()">{{ words['myf2g.login.silentreg.not.receive'] }}</div>
            </div>
        </div>
      </div>
    </form>
   </ValidationObserver>
</template>


<script>

import store from '../store/store'
import router from '../router/router'
import _ from 'lodash'

export default {
  name: 'SilentRegistrationForm',
  data: function() {
      return {
          words: {},
          otp: '',
          email: '',
          termsOfUse: false,
          responseErrorLevel: 0,
          responseErrorMessage: '',
          responseErrorCode: 0,
          newsLetterRegister: false,
          isComponentLoaded: false
      }
  },
  computed: {
      tai() {
        return store.state.tai;
      },
      locale() {
          return store.state.locale;
      },
      silentRegistrationFormWords() {
          return store.state.silentRegistrationFormWords;
      },
      msisdn() {
          return store.state.msisdn;
      },
      termsAndConditionsRedirection() {
        if (this.locale == "en_US") {
            return "/gr/oroi-hrisis/"
        } else {
            return "/gr/oroi-hrisis/"
        }
      },
  },
  watch: {
    otp() {
      if (this.responseErrorLevel != 0) {
        this.responseErrorLevel = 0;
        this.responseErrorMessage = '';
        this.responseErrorCode = '';
      }
    },
    email() {
      if (this.responseErrorLevel != 0) {
        this.responseErrorLevel = 0;
        this.responseErrorMessage = '';
        this.responseErrorCode = '';
      }
    },
    termsOfUse() {
      if (this.responseErrorLevel != 0) {
        this.responseErrorLevel = 0;
        this.responseErrorMessage = "";
        this.responseErrorCode = "";
      }
    },
    isComponentLoaded() {
        console.log("isComponentLoaded: "+this.isComponentLoaded);
        if (this.isComponentLoaded) {
            var self = this;
            this.$nextTick(function(){
                console.log("nexttick called");
                self.bindJSFunctionality();
            })
        }
    }
  },
  beforeMount() {
    if ( sessionStorage.getItem("wcs_myf2gloginsilentregistrationform_"+this.locale) != null ) {
      this.words = JSON.parse(sessionStorage.getItem("wcs_myf2gloginsilentregistrationform_"+this.locale));
      this.isComponentLoaded = true;
    } else {
        
        let config = {
            method: 'get',
            url: '/gr/f2g/vueContentService/',
            params: {
                ciKey: 'myf2gloginsilentregistrationform',
                locale: this.locale,
            }
        }
        
        let self = this;
        this.axios(config).then(function(response){
            console.log(response);
            self.words = response.data;
            sessionStorage.setItem("wcs_myf2gloginsilentregistrationform_"+self.locale, JSON.stringify(self.words));
            self.isComponentLoaded = true;

        }).catch(function(error){
            console.error(error);
        })
    }
  },
  methods: {
      goBackToMobileForm() {
          router.push({
              name: 'MobileForm'
          })
      },
      submitForm() {
        
        //construct the request
        let request = {}

        //construct the caller
        request.caller = {};
        request.caller.callingSystem = "myF2Gweb";
        request.caller.salesCode = "";
        request.caller.username = "anonymous";
        request.caller.locale = this.locale;
        request.caller.channel = "F2G";
        
        //construct the request info
        request.msisdn = this.msisdn;
        request.otp = this.otp;
        request.createUser = true;
        request.newsLetterRegister = this.newsLetterRegister;
        request.email = this.email;
        request.tai = this.tai;
    
        //construct the axios configuration
        let config = {
            method: 'post',
            url: '/apiv2/login/msisdnLogin/',
            data: request
        }

        let self = this;
        //Show loader
        
        this.axios(config).then(function(response){

            if (response.data.errorLevel == 0) {

                handleDataLayer.init();
                handleDataLayer.pushSimpleDataLayer("myf2glogin");
                //Redirect to the front page
                sessionStorage.setItem("keepAliveTimestamp", Date.now());
                window.location.href = response.data.redirectLocation;

            } else {
                //Handle Error Level 1
                self.responseErrorLevel = response.data.errorLevel;
                self.responseErrorMessage = response.data.errorMessage;
                self.responseErrorCode = response.data.errorCode;

            }
         
        }).catch(function(error){
            console.error(error);
        }).then(function(){
            //hide loader
        })

    },
    bindJSFunctionality() {

        console.log("bindJSFunctionality called");

        $('input').focus(function(){
          $(this).parents('.form-field').addClass('focused');
        });
        
        $('input').blur(function(){
          var inputValue = $(this).val();
          if ( inputValue == "" ) {
          $(this).removeClass('filled');
          $(this).parents('.form-field').removeClass('focused');  
          } else {
          $(this).addClass('filled');
          }
        })

        console.log("focus-blur bind");
    }
  }
}
</script>

